import { render, staticRenderFns } from "./DropdownItemsDialog.vue?vue&type=template&id=dfa22098&"
import script from "./DropdownItemsDialog.vue?vue&type=script&lang=js&"
export * from "./DropdownItemsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports